/* eslint-disable react-hooks/exhaustive-deps */
/* eslint-disable no-unused-vars */
import React, { useState } from "react";
import Layout from "../Layout/Layout";
import NewLoginRegister from "../Layout/NewLoginRegister";
import { Link } from "react-router-dom";
const LoginSignup = () => {
 

   const [show, setShow] = useState(true);

     return (
      <Layout
        title="Log in:  Chaashni by Maansi & Ketan"
        description="Chaashni by Maansi & Ketan: Description"
      >
        <div className="site-content-wrap login new-login-page">
          <div className="loginbox">
            <h2>LOGIN / SIGN UP</h2>
            <div className="login-inner">             
              <div className="login-content loading-old">
                <div className="app__container">
                  <NewLoginRegister show={show} redirect={true} locationPath={'loginPage'} />
                  <div className="t-and-c-box">By continuing, you agree to Chaashni <Link to="/pages/terms-conditions" target="_blank">Terms & Conditions</Link> of Use and <Link to="/pages/privacy-policy" target="_blank">Privacy Policy</Link>.</div>                                
                </div>
              </div>
            </div>
          </div>
        </div>
      </Layout>
    );
 
};

export default LoginSignup;
